import axios from "axios";
import {
  LOGIN_FAILED,
  LOGIN_SUCCESS,
  TOKEN_CHECK,
  TOKEN_CHECK_FAIL,
  LOGOUT,
  BACKEND_URL,
  RESET_SUCCESS,
  RESET_FAILED,
  GET_USER_DATA_BY_EMAIL,
  SET_LOADING_FALSE,
  SET_LOGOUT_PROVISION,
  RESET_LOGIN_FAILED,
  OTP_SETTING,
  CUSTOM_USER,
  BACKEND_URL_2,
  IDLE_TIMEOUT,
  SET_OTP_TIMEOUT,
  OTP_FREEZE,
  SET_CHECK_TOKEN_BOOL,
  LIST_USER_ROLES,
  SET_SELECTED_USER_ROLE,
} from "../../actions/types";
import setAuthToken from "../../utils/setAuthToken";
import store from "../../redux/store";
import { listCompany } from "../dashboard/company";
import { listUsersData } from "../dashboard/userManagement";
// import { listCompliances } from "../dashboard/complianceMaster";
import { Crypt } from "hybrid-crypto-js";
import { checkProgressDetails } from "./user";
import { sortRolesByRank } from "../../utils/roleUtils";
const publicKey = `-----BEGIN PUBLIC KEY-----
MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC13UDmL+Acqc2LJGyrBGJTnb2o
9KvnrFftGSQPvE1tDoqV6Ms2602sQVL/TX4inZuDr5axIBNIdWsuU6xe0eX3TMw5
2WOnTcNtLFDiCB1IaWGgOHWQ1kaL5coz4v+PR4ymPfBLZSqS+c0BzM6RWyXnsFv8
Br7O1xXKjDpKozcQCQIDAQAB
-----END PUBLIC KEY-----`;

//check token
export const loadUser = () => async (dispatch) => {
  let data = localStorage.getItem("paramsListData");
  let flag = true;
  if (data) {
    data = JSON.parse(data);
    flag = data.task !== "approve";
  }
  if (localStorage.token && flag) {
    setAuthToken(localStorage.token);
    await axios({
      method: "POST",
      url: BACKEND_URL + "access/check-token",
      data: {},
    })
      .then(async (response) => {
        if (response.data.statuscode === 200) {
          await dispatch({
            type: IDLE_TIMEOUT,
            payload: response.data.idle_time,
          });
          // Only rotate token when backend sends new_token; otherwise keep current token to avoid 403
          const tokenToUse =
            response.data.new_token != null && response.data.new_token !== ""
              ? response.data.new_token
              : localStorage.token;
          setAuthToken(tokenToUse);
          if (tokenToUse !== localStorage.token) {
            localStorage.setItem("token", tokenToUse);
          }
          localStorage.setItem("current_user_id", response.data.user_id);
          localStorage.setItem("role", response.data.role[0]);
          await dispatch({
            type: TOKEN_CHECK,
            payload: {
              token: tokenToUse,
              data: response.data.role,
              company_id: response.data.company_id,
            },
          });
          dispatch(listRolesByCompany(response.data.company_id));
          setTimeout(async () => {
            if (!store.getState().auth.isAuthenticated) return;
            if (response.data.role[0] === "CUSTOM-USER") {
              // console.log(response.data.role)
              await dispatch(customUser());
            }
            await dispatch(getUserData(store.getState().auth.data.email));
            await dispatch(listCompany());
            dispatch(listUsersData());
            dispatch({ type: SET_CHECK_TOKEN_BOOL, payload: true });
            // dispatch(listCompliances());
            dispatch(checkProgressDetails());
          }, 100);
        } else if (response.data.statuscode === 403) {
          await dispatch({ type: SET_LOGOUT_PROVISION });
        } else {
          dispatch({
            type: TOKEN_CHECK_FAIL,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: TOKEN_CHECK_FAIL,
        });
      });
  } else {
    if (flag) {
      dispatch({ type: SET_LOADING_FALSE });
      await dispatch({ type: LOGOUT });
    }
  }
};

//CUSTOMUSER ROLE
export const customUser = () => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  const body = {};
  await axios({
    method: "POST",
    url: BACKEND_URL_2 + "project-management/get-user-role-by-token",
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: CUSTOM_USER,
          payload: response.data.role_name,
        });
      } else {
        dispatch({
          type: CUSTOM_USER,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: LOGIN_FAILED,
        payload: { message: "server error" },
      });
    });
};
//Login user
export const login = (email, password) => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  var crypt = new Crypt();
  var encrypted = crypt.encrypt(publicKey, password);
  var data = JSON.parse(encrypted);
  var encData =
    data.iv + "$|" + data.cipher + "$|" + data.keys[Object.keys(data.keys)[0]];

  const body = { email, password: encData };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/loginapi",
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        localStorage.setItem("showPopup", "yes");
        dispatch({
          type: OTP_SETTING,
          payload: response.data,
        });
        // dispatch(loadUser());
      } else {
        dispatch({
          type: LOGIN_FAILED,
          payload: { message: response.data.message, type: "LOGIN" },
        });
        setTimeout((e) => {
          dispatch({ type: RESET_LOGIN_FAILED });
        }, 6000);
      }
    })
    .catch((error) => {
      dispatch({
        type: LOGIN_FAILED,
        payload: {
          message: error?.response?.data.hasOwnProperty("message")
            ? error.response.data.message
            : "server error",
          type: "LOGIN",
        },
      });
      setTimeout((e) => {
        dispatch({ type: RESET_LOGIN_FAILED });
      }, 6000);
    });
};

//otp
//Login user
export const OTPloginAPi = (otp) => async (dispatch) => {
  dispatch({ type: OTP_FREEZE, payload: true });
  const config = {
    "Content-Type": "application/json",
  };
  const body = { email: localStorage.getItem("email"), otp };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/validate-otp",
    data: body,
    headers: config,
  })
    .then(async (response) => {
      if (response.data.statuscode === 200) {
        await dispatch({
          type: LOGIN_SUCCESS,
          payload: response.data,
        });
        await dispatch(loadUser());
      } else {
        dispatch({
          type: LOGIN_FAILED,
          payload: response.data,
        });
        setTimeout((e) => {
          dispatch({ type: RESET_LOGIN_FAILED });
        }, 6000);
      }
      await dispatch({ type: OTP_FREEZE, payload: false });
    })
    .catch((error) => {
      dispatch({ type: OTP_FREEZE, payload: false });
      dispatch({
        type: LOGIN_FAILED,
        payload: {
          message: error.response.data.hasOwnProperty("message")
            ? error.response.data.message
            : "server error",
        },
      });
      setTimeout((e) => {
        dispatch({ type: RESET_LOGIN_FAILED });
      }, 6000);
    });
};

export const SssoLoginValidate = (meta_data) => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  const body = { meta_data };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/validate-adfs-token",
    data: body,
    headers: config,
  })
    .then(async (response) => {
      if (response.data.statuscode === 200) {
        localStorage.setItem("company_id", response.data.company_id);
        localStorage.setItem("email", response.data.email);
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("role", response.data.role);
        localStorage.setItem("token", response.data.token);
        window.location.href = "/app";
        // await dispatch(loadUser());
      } else {
        dispatch({
          type: LOGIN_FAILED,
          payload: { message: response.data.message, type: "LOGIN" },
        });
        setTimeout((e) => {
          dispatch({ type: RESET_LOGIN_FAILED });
        }, 6000);
      }
    })
    .catch((error) => {
      dispatch({
        type: LOGIN_FAILED,
        payload: {
          message: error.response.data.hasOwnProperty("message")
            ? error.response.data.message
            : "server error",
          type: "LOGIN",
        },
      });
      setTimeout((e) => {
        dispatch({ type: RESET_LOGIN_FAILED });
      }, 6000);
    });
};

//LOGOUT
export const logout = () => async (dispatch) => {
  if (localStorage.getItem("token") === null) {
    return;
  }
  const body = { email: store.getState().auth.data.email };
  const config = {
    "Content-Type": "application/json",
  };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/logout",
    data: body,
    headers: config,
  })
    .then(async (response) => {
      if (response.data.statuscode === 200) {
        await dispatch({ type: LOGOUT });
        localStorage.clear();
      } else if (response.data.statuscode === 403) {
        await dispatch({ type: SET_LOGOUT_PROVISION });
      } else {
      }
    })
    .catch((error) => {});
};

//forgot password
export const forgotPassword = (email) => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  const body = { email };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/reset-password",
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: RESET_SUCCESS,
          payload: response.data,
        });
        setTimeout((e) => {
          dispatch({ type: RESET_LOGIN_FAILED });
        }, 6000);
      } else {
        dispatch({
          type: RESET_FAILED,
          payload: response.data,
        });
        setTimeout((e) => {
          dispatch({ type: RESET_LOGIN_FAILED });
        }, 6000);
      }
    })
    .catch((error) => {
      dispatch({
        type: RESET_FAILED,
        payload: { message: "server error" },
      });
      setTimeout((e) => {
        dispatch({ type: RESET_LOGIN_FAILED });
      }, 6000);
    });
};

//OTP Timer for reset password
export const getOtpTime = (email) => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  const body = { email };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/get-otp-expiry-duration",
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: SET_OTP_TIMEOUT,
          payload: response.data.duration,
        });
      } else {
        dispatch({
          type: SET_OTP_TIMEOUT,
          payload: 0,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: SET_OTP_TIMEOUT,
        payload: 0,
      });
    });
};

//OTP Timer for reset password
export const resendOtp = (email) => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  const body = { email };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/resend-otp",
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: SET_OTP_TIMEOUT,
          payload: response.data.duration,
        });
      } else {
        dispatch({
          type: SET_OTP_TIMEOUT,
          payload: 0,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: SET_OTP_TIMEOUT,
        payload: 0,
      });
    });
};

//reset password
export const resetPassword = (email, otp, new_password) => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  var crypt = new Crypt();
  var encrypted = crypt.encrypt(publicKey, new_password);
  var data = JSON.parse(encrypted);
  var encData =
    data.iv + "$|" + data.cipher + "$|" + data.keys[Object.keys(data.keys)[0]];
  const body = { email, otp, new_password: encData };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/update-password",
    data: body,
    headers: config,
  })
    .then((response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: RESET_SUCCESS,
          payload: response.data,
        });
        setTimeout((e) => {
          dispatch({ type: RESET_LOGIN_FAILED });
        }, 6000);
      } else {
        dispatch({
          type: RESET_FAILED,
          payload: response.data,
        });
        setTimeout((e) => {
          dispatch({ type: RESET_LOGIN_FAILED });
        }, 6000);
      }
    })
    .catch((error) => {
      dispatch({
        type: RESET_FAILED,
        payload: { message: "server error" },
      });
      setTimeout((e) => {
        dispatch({ type: RESET_LOGIN_FAILED });
      }, 6000);
    });
};

// Resolve the company id we should pass to list-roles-by-company:
// prefer the top-nav-selected company, fall back to the check-token company_id.
const resolveRolesCompanyId = (fallbackCompanyId) => {
  const stored = localStorage.getItem("company_selected");
  if (stored != null && String(stored).trim() !== "") {
    const parsed = parseInt(stored, 10);
    if (!Number.isNaN(parsed)) return parsed;
  }
  return fallbackCompanyId;
};

// Pick the role to keep active after a roles refresh: keep prior selection
// if still valid, otherwise default to the first role in the list.
const pickDefaultSelectedRole = (rolesList) => {
  if (!Array.isArray(rolesList) || rolesList.length === 0) return null;
  const prior = localStorage.getItem("selected_user_role");
  if (prior && rolesList.includes(prior)) return prior;
  return rolesList[0];
};

// List roles available to the logged-in user for the selected company.
// Triggered immediately after check-token succeeds and whenever the top
// nav company selection changes.
export const listRolesByCompany =
  (companyId) => async (dispatch) => {
    const company = resolveRolesCompanyId(companyId);
    if (company == null) return;
    const config = { "Content-Type": "application/json" };
    const body = { company };
    await axios({
      method: "POST",
      url: BACKEND_URL + "org/list-roles-by-company",
      data: body,
      headers: config,
    })
      .then((response) => {
        if (response.data.statuscode === 200) {
          // Sort roles so the highest-privilege role (SUPER-USER) appears first
          // in the dropdown and is the default selection on first load.
          const rolesList = sortRolesByRank(
            response.data?.data?.[0]?.roles ?? []
          );
          const otherRoles = response.data?.other_roles ?? {};
          const selected = pickDefaultSelectedRole(rolesList);
          if (selected) {
            localStorage.setItem("selected_user_role", selected);
            // Keep legacy `role` in sync — many screens read localStorage.role
            // directly for role-based rendering and filters.
            localStorage.setItem("role", selected);
          } else {
            localStorage.removeItem("selected_user_role");
          }
          dispatch({
            type: LIST_USER_ROLES,
            payload: {
              roles: rolesList,
              otherRoles,
              data: response.data?.data ?? [],
            },
          });
          dispatch({
            type: SET_SELECTED_USER_ROLE,
            payload: selected,
          });
        } else {
          dispatch({
            type: LIST_USER_ROLES,
            payload: { roles: [], otherRoles: {}, data: [] },
          });
          dispatch({ type: SET_SELECTED_USER_ROLE, payload: null });
        }
      })
      .catch(() => {
        dispatch({
          type: LIST_USER_ROLES,
          payload: { roles: [], otherRoles: {}, data: [] },
        });
        dispatch({ type: SET_SELECTED_USER_ROLE, payload: null });
      });
  };

// Apply the role the user picked from the avatar dropdown. Persists to
// localStorage so axios interceptor on /v25/ requests can pick it up
// without a redux dependency.
export const setSelectedUserRole = (role) => (dispatch) => {
  if (role) {
    localStorage.setItem("selected_user_role", role);
    localStorage.setItem("role", role);
  } else {
    localStorage.removeItem("selected_user_role");
  }
  dispatch({ type: SET_SELECTED_USER_ROLE, payload: role });
};

//get user data
export const getUserData = (email) => async (dispatch) => {
  const config = {
    "Content-Type": "application/json",
  };
  const body = { email };
  await axios({
    method: "POST",
    url: BACKEND_URL + "access/list-user-byemail",
    data: body,
    headers: config,
  })
    .then(async (response) => {
      if (response.data.statuscode === 200) {
        dispatch({
          type: GET_USER_DATA_BY_EMAIL,
          payload: response.data,
        });
      } else if (response.data.statuscode === 403) {
        await dispatch({ type: SET_LOGOUT_PROVISION });
      } else {
      }
    })
    .catch((error) => {});
};
